var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cu-checkbox"},[(_vm.skeletonLoader)?_c(_setup.CUSkeletonLoaderCheckbox,{attrs:{"label-width":_vm.labelWidth,"hide-details":_setup.hideDetails}}):_c('v-checkbox',_vm._g(_vm._b({class:_setup.checkboxClass,attrs:{"input-value":_vm.value}},'v-checkbox',_setup.attrs,false),_setup.listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }